// CONSTANTS
import { getFormValues, initialize, reset } from 'redux-form';
import { formName as wagonFormName } from '../preAdviceWagonFormUtils';
import { formName } from './copyAteNumbersFormUtils';
import { getCopyAteNumbersState, getPreAdvice } from '../../../commons/selectors/selectors';
import { successUpdateWagons } from '../../pre-advice/preAdviceDucks';
import { startToast } from '../../../commons/components/toast/toastDucks';
import apiHelper from '../../../api/apiHelper';

const OPEN_COPY_ATENUMBERS_DIALOG = 'OPEN_COPY_ATENUMBERS_DIALOG';
const CLOSE_COPY_ATENUMBERS_DIALOG = 'CLOSE_COPY_ATENUMBERS_DIALOG';

// REDUCER
const initialState = {
  open: false,
  nbWagons: null,
  frenchAteNumber: null,
  foreignAteCountry: null,
  foreignAteNumber: null,
  speedLimit: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_COPY_ATENUMBERS_DIALOG:
      return { ...state, open: true, ...action.payload };
    case CLOSE_COPY_ATENUMBERS_DIALOG:
      return { ...state, ...initialState };
    default:
      return state;
  }
};

// ACTIONS
export const openCopyAteNumbersDialog = (wagon) => (dispatch, getState) => {
  const state = getState();
  const {
    ateNumbers: { frenchAteNumber, foreignAteCountry, foreignAteNumber, speedLimit },
  } = getFormValues(wagonFormName)(state);
  console.log({ frenchAteNumber, foreignAteCountry, foreignAteNumber, speedLimit });
  const preAdvice = getPreAdvice(state);
  dispatch({
    type: OPEN_COPY_ATENUMBERS_DIALOG,
    payload: {
      nbWagons: 0,
      frenchAteNumber,
      foreignAteCountry,
      foreignAteNumber,
      speedLimit,
    },
  });
  dispatch(initialize(formName, { fromWagon: wagon.position + 1, toWagon: preAdvice.getNbWagons() }));
};

export const closeCopyAteNumbersDialog = () => (dispatch) => {
  dispatch({
    type: CLOSE_COPY_ATENUMBERS_DIALOG,
  });
  dispatch(reset(formName));
};

export const confirmCopyAteNumbers =
  ({ fromWagon, toWagon }) =>
  async (dispatch, getState) => {
    const state = getState();
    const preAdvice = getPreAdvice(getState());
    const { frenchAteNumber, foreignAteCountry, foreignAteNumber, speedLimit } = getCopyAteNumbersState(state);

    try {
      const serverWagons = await apiHelper.post(`/api/pre-advices/${preAdvice.id}/copy-ate-numbers`, {
        preAdviceId: preAdvice.id,
        fromWagon,
        toWagon,
        frenchAteNumber,
        foreignAteCountry,
        foreignAteNumber,
        speedLimit,
      });
      dispatch(successUpdateWagons(serverWagons));
      dispatch(closeCopyAteNumbersDialog());
      dispatch(
        startToast({
          text: `Transport exceptionnel propagé sur ${serverWagons.length} wagons.`,
          className: 'success',
        }),
      );
    } catch {
      dispatch(startToast({ text: 'Erreur : Transport exceptionnel non propagé.', className: 'error' }));
    }
  };
